<script setup>
import { makeLogger } from "@/shared/consola";
import { useRoute } from "vue-router";
import { computed, onMounted, ref, watch } from "vue";
import { issuedCertificatesService } from "@/apps/player/services/issued-certificates.service";
import CertificateBody from "@/views/tools/player/certificate/CertificateBody.vue";
import BadgeBody from "@/views/tools/player/certificate/BadgeBody.vue";
import { usePreviewLanguage } from "@/shared/utils/router/usePreviewLanguage";
import { RENDER_ROUTE_NAMES } from "@/views/render/render.routes";
import { setFontFamily } from "@/shared/utils";

const issuedCertificate = ref({});
const certPlayer = ref({});
const certTemplate = computed(() => issuedCertificate.value?.certificate || {});
const certContent = computed(() => issuedCertificate.value?.certificate?.content || {});
const logger = makeLogger("PlayerCertificatePage");
const route = useRoute();
const { setLanguageIfNoQuery } = usePreviewLanguage();
const currentFont = ref("Inter");

const isBadgeMode = ref(false);

onMounted(async () => {
    try {
        const { issuedCert, player } = await issuedCertificatesService.getOnePublic(
            route.params.projectUuid,
            route.params.certificateUuid
        );

        issuedCertificate.value = issuedCert;
        certPlayer.value = player;

        setLanguageIfNoQuery(player?.user?.language);

        setFontFamily(player.fontFamily, currentFont);

        watch(
            () => route.name,
            () => {
                isBadgeMode.value = route.name === RENDER_ROUTE_NAMES.playerBadge;
            },
            {
                immediate: true,
            }
        );
    } catch (error) {
        logger.error(error);
    }
});
</script>

<template>
    <CertificateBody
        v-if="issuedCertificate.uuid && !isBadgeMode"
        :player="certPlayer"
        :certTemplate="certTemplate"
        :issuedCert="issuedCertificate"
        :certContent="certContent"
    />
    <BadgeBody
        v-if="issuedCertificate.uuid && isBadgeMode"
        :player="certPlayer"
        :certTemplate="certTemplate"
        :issuedCert="issuedCertificate"
        :certContent="certContent"
    />
</template>
